// src/App.jsx
import React from 'react';
import AppRoutes from './Routes';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;